import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  CircularProgress,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import Pagination from "@mui/material/Pagination";

const DashboardViewNotif = ({
  open,
  notif,
  onNext,
  isLast,
  pageIndex,
  total,
  onSelectPage,
  onCloseAll,
  onSkip,
}) => {
  const [loading, setLoading] = useState(false);
  const [acknowledged, setAcknowledged] = useState(false);
  if (!notif) return null;

  const handleClose = async () => {
    if (!acknowledged) {
      onSkip?.();
      return;
    }

    setLoading(true);
    await onCloseAll();
    setLoading(false);
  };

  const renderPagination = () => (
    <Box mt={2} display="flex" justifyContent="center">
      <Pagination
        count={total}
        page={pageIndex + 1}
        onChange={(e, value) => onSelectPage(value - 1)}
        color="primary"
        shape="rounded"
        size="small"
      />
    </Box>
  );

  return (
    <Dialog open={open} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Typography variant="h6" align="center">
          {notif.name}
        </Typography>
      </DialogTitle>

      <DialogContent dividers>
        <Box
          mb={2}
          sx={{
            fontSize: "16px",
            lineHeight: 1.6,
            wordBreak: "break-word",
            "& .ql-align-center": { textAlign: "center" },
            "& .ql-align-right": { textAlign: "right" },
            "& .ql-align-left": { textAlign: "left" },
          }}
          dangerouslySetInnerHTML={{ __html: notif.description }}
        />

        {notif.imgUrl && (
          <Box display="flex" justifyContent="center" mt={3}>
            <img
              src={notif.imgUrl}
              alt="Notification Visual"
              style={{ maxWidth: "100%", maxHeight: 300, borderRadius: 8 }}
            />
          </Box>
        )}

        {renderPagination()}
      </DialogContent>

      <DialogActions sx={{ justifyContent: "space-between", px: 3 }}>
        <Box>
          <Typography variant="body2" color="textSecondary">
            {`Notification ${pageIndex + 1} of ${total} | ${new Date(
              notif.createdAt
            ).toLocaleString()}`}
          </Typography>
        </Box>

        <Box display="flex" alignItems="center" gap={2}>
          <FormControlLabel
            control={
              <Checkbox
                checked={acknowledged}
                onChange={(e) => setAcknowledged(e.target.checked)}
              />
            }
            label="Acknowledge"
          />
          <Button
            variant="outlined"
            onClick={handleClose}
            disabled={loading}
            startIcon={loading && <CircularProgress size={18} />}
          >
            {loading ? "Please wait" : acknowledged ? "OK" : "Skip"}
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default DashboardViewNotif;
